import type { PropsWithChildren } from 'react';
import React, { useCallback } from 'react';
import type { ChannelListMessengerProps } from 'stream-chat-react';
import { FAIcon } from '~/components/utils/FAIcons';
import { useStreamChatContext } from '~/react_context/StreamChatContext';

export type TeamChannelListProps = ChannelListMessengerProps & {
	title?: string;
	type: ChannelType;
	showAddChannelButton?: boolean;
};

const ChannelList = (props: PropsWithChildren<TeamChannelListProps>) => {
	const { onAddChannelClick } = useStreamChatContext();
	const { showAddChannelButton = true, children, error = false, loading, type } = props;

	const handleAddChannelClick = useCallback(() => {
		onAddChannelClick(type);
	}, [onAddChannelClick, type]);

	if (error) {
		console.error('Error listing Stream Chat channels', error);
		return type === 'team' ? (
			<div className="team-channel-list">
				<p className="team-channel-list__message">Unable to list channels.</p>
			</div>
		) : null;
	}

	if (loading) {
		return (
			<div className="team-channel-list">
				<p className="team-channel-list__message loading">{type === 'team' ? 'Channels' : 'Messages'} loading....</p>
			</div>
		);
	}

	return (
		<div>
			<div className="flex items-center justify-between">
				<p className="text-sm font-semibold">{props.title ?? (type === 'team' ? 'Channels' : 'Direct Messages')}</p>
				{showAddChannelButton && (
					<button onClick={handleAddChannelClick} type="button">
						<FAIcon icon="plus" />
					</button>
				)}
			</div>
			{children}
		</div>
	);
};

export const TeamChannelList = ChannelList;
